

const { classesRuntime, statesRuntime } = require("./../../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_177_0_BrandColors";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_177_0_BrandColors__root"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {"D10":"#000624","D20":"#333850","D30":"#595D70","D40":"#868AA5","D50":"#B6C1CD","D55":"#CFD1DC","D60":"#DFE5EB","D70":"#ECEFF3","B05":"#0F62E6","B10":"#116DFF","B20":"#5999FF","B30":"#7CAFFF","B40":"#D3E4FF","B50":"#E8F1FF","B60":"#F8FAFF","D80":"#FFFFFF","P00":"#8E21B1","P10":"#AA4DC8","P20":"#CD68ED","D10-30":"rgba(0, 6, 36, 0.3)","D10-40":"rgba(0, 6, 36, 0.4)","D10-50":"rgba(0, 6, 36, 0.5)","D80-70":"rgba(255, 255, 255, 0.7)","G10":"#51B77B","G20":"#51B77B","G40":"#CDF2CF","R10":"#EE4437","R20":"#F1695F","R30":"#F69891","R40":"#FDE3E1","R50":"#FDECEB","Y10":"#F9aD4D","O10":"#F96132","Y30":"#FFD16E","Y50":"#FFF7E2","A2":"#5A48F5","A3":"#06BEE1","A4":"#CDC8FC","A5":"#FBAD4E","S10":"#131720","S10-05":"#1F222B","S10-10":"#2B2E36","S10-20":"#42454C","S10-30":"#5A5D63","S10-40":"#717379","S10-50":"#898B8F","S10-60":"#A0A2A5","S10-70":"#B8B9BC","S10-80":"#CFD0D2","S10-90":"#E7E8E9","S10-100":"#FFFFFF","BR10":"#000000","BR20":"#333853","BR30":"#B5B5B5","BR40":"#C0C2CE","BR50":"#D4D4D4"}; 
module.exports.vars = {}; 




